/**
 * SubscribeUserSheet
 *
 * Helper to open the subscribe-user bottom sheet via SheetService. Mirrors
 * the pattern of `UnlockContentSheet.tsx`.
 *
 * Usage:
 *   SubscribeUserSheet.show({
 *     targetFirebaseId: user.firebaseId,
 *     preloadedUser: user,
 *     screenKey,
 *     container,
 *   });
 *
 * Flutter: lib/services/navigation_service.dart -> showSubscribeUserBottomSheet()
 */
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { SubscribeUserSheetContent } from './SubscribeUserSheetContent';
import type { UserEntity } from '@/domain/entities/user/userEntity';

export interface SubscribeUserSheetConfig {
  targetFirebaseId: string;
  preloadedUser?: UserEntity | null;
  screenKey?: string;
  container?: HTMLElement | string | null;
}

const show = (config: SubscribeUserSheetConfig): void => {
  SheetService.show({
    content: (
      <SubscribeUserSheetContent
        targetFirebaseId={config.targetFirebaseId}
        preloadedUser={config.preloadedUser ?? null}
        screenKey={config.screenKey}
      />
    ),
    container: config.container,
    screenKey: config.screenKey,
    closeOnClickOutside: true,
  });
};

export const SubscribeUserSheet = {
  show,
};
